import React from 'react';
import {injectIntl} from 'react-intl';
import Alert from 'react-bootstrap/Alert';

import API from '../../common/utils/API';
import StarterList from '../../components/starter/StarterList';

export class ServiceList extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            services: [],

            // Meta pagination
            page: 1,
            pageSize: 12,
            total: 0,

            // Search
            searchTimeout: 0,
            search: '',

            // Error
            error: false,

            // Loading
            loading: false,
        };
    }

    async componentDidMount() {
        await this.fetchServices();
    }

    fetchServices = async (pageNumber = 1) => {
        this.setState({loading: true});

        try {
            const result = await API.services.get({
                page: pageNumber,
                search: this.state.search,
            });

            this.setState({
                services: result.items,
                page: result.page,
                pageSize: result.pageSize,
                total: result.total,
                error: false,
                loading: false,
            });
        } catch (e) {
            this.setState(
                {
                    error: true,
                    loading: false,
                },
                this.clearErrorMessage,
            );
        }
    };

    clearErrorMessage = () => {
        setTimeout(() => {
            if (this.state.error) {
                this.setState({error: false});
            }
        }, 5000);
    };

    handlePageChange = (pageNumber) => {
        return this.fetchServices(pageNumber);
    };

    handleSearchKeywordChange = (event) => {
        /* istanbul ignore else */
        if (this.state.searchTimeout) {
            clearTimeout(this.state.searchTimeout);
        }

        this.setState({
            [event.target.name]: event.target.value,
            searchTimeout: setTimeout(() => {
                return this.fetchServices(1);
            }, 300),
        });
    };

    handleSearchKeywordClear = () => {
        this.setState(
            {
                pageSize: 1,
                search: '',
            },
            () => {
                return this.fetchServices(1);
            },
        );
    };

    render() {
        return (
            <div data-test='serviceListComponent'>
                <Alert
                    data-test='errorAlert'
                    variant='danger'
                    className='mb-4'
                    show={this.state.error}
                >
                    <p className='mb-0'>
                        {this.props.intl.formatMessage({
                            id: 'ERROR_PAGES.LOADING_DATA',
                        })}
                    </p>
                </Alert>
                <StarterList
                    onSearchKeywordClear={this.handleSearchKeywordClear}
                    onSearchKeywordChange={this.handleSearchKeywordChange}
                    searchKeyword={this.state.search}
                    onPageChange={this.handlePageChange}
                    page={this.state.page}
                    pageSize={this.state.pageSize}
                    total={this.state.total}
                    loading={this.state.loading}
                    data={{
                        headerTitles: [
                            '#',
                            this.props.intl.formatMessage({
                                id: 'SERVICES.SERVICE_NAME_TABLE_HEADER',
                            }),
                            this.props.intl.formatMessage({
                                id: 'SERVICES.SERVICE_ORDER_TABLE_HEADER',
                            }),
                        ],
                        rows: this.state.services.map((service) => ({
                            content: [service.id, service.name, service.order],
                            link: `/services/${service.id}`,
                        })),
                    }}
                    addNewPermission={'SERVICES_CREATE'}
                    addNewLink={`/services/create`}
                />
            </div>
        );
    }
}

export default injectIntl(ServiceList);
